import type { ReactNode, MouseEventHandler } from 'react';
import { ActionIcon, Tooltip, type ActionIconProps } from '@mantine/core';

/**
 * Icon-only control — always requires accessible label (tooltip + aria-label).
 */
export function IconButtonWithTooltip({
  label,
  children,
  onClick,
  disabled,
  ...props
}: {
  label: string;
  children: ReactNode;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
} & Omit<ActionIconProps, 'children' | 'aria-label' | 'onClick'>) {
  return (
    <Tooltip label={label} withArrow>
      <ActionIcon
        aria-label={label}
        variant="subtle"
        color="gray"
        disabled={disabled}
        onClick={onClick}
        {...props}
      >
        {children}
      </ActionIcon>
    </Tooltip>
  );
}

export { ActionIcon };
